var inline = {
  exports: {}
};

export { inline as i };
//# sourceMappingURL=inline.js.map
